// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
  E.g. 
  @include mix.position-fix(-15px, 0 0 -15px 0);
  @include mix.respond(1280px) { @include mix.position-reset(); }
*/
.asterisk_input::after {
  content: " *";
  color: #ba5a73;
}

.mat-stepper-horizontal {
  margin-top: 8px;
}

.uploaded-document {
  align-items: center;
  display: flex;
  justify-content: space-between;
  padding: 0.85em 0;
}
.uploaded-document:first-of-type {
  padding-top: 0;
}
.uploaded-document:last-of-type {
  padding-bottom: 0;
}
.uploaded-document:not(:last-of-type) {
  border-bottom: 1px solid rgba(0, 0, 0, 0.07);
}
.uploaded-document p {
  margin-bottom: 0;
  margin-top: 0;
}
.uploaded-document__item {
  display: flex;
}
.uploaded-document__title {
  margin-right: 25px;
}
.uploaded-document__remove {
  font-size: 25px;
}

.mat-mdc-raised-button.mat-blue {
  background-color: #5479b9;
  color: white;
}

.mat-mdc-raised-button.mat-gray {
  background-color: #c7c7c7;
  color: white;
}`, "",{"version":3,"sources":["webpack://./src/styles/abstracts/_mixins.scss","webpack://./src/app/shared/components/document-upload/upload-modal-short/upload-modal-short.component.scss"],"names":[],"mappings":"AAyBE;;;;CAAA;ACtBF;EACE,aAAA;EACA,cAAA;AAGF;;AAAA;EACE,eAAA;AAGF;;AAAA;EACE,mBAAA;EACA,aAAA;EACA,8BAAA;EACA,iBAAA;AAGF;AADE;EACE,cAAA;AAGJ;AAAE;EACE,iBAAA;AAEJ;AACE;EACE,4CAAA;AACJ;AAEE;EACE,gBAAA;EACA,aAAA;AAAJ;AD9BI;ECkCA,aAAA;AADJ;ADjCI;ECsCA,kBAAA;AAFJ;ADpCI;EC6CA,eAAA;AANJ;;AAUA;EACE,yBAAA;EACA,YAAA;AAPF;;AAUA;EACE,yBAAA;EACA,YAAA;AAPF","sourcesContent":["// BEM Mixins\r\n@mixin e($element) {\r\n    &__#{$element} {\r\n      @content;\r\n    }\r\n  }\r\n  @mixin m($modifier) {\r\n    &--#{$modifier} {\r\n      @content;\r\n    }\r\n  }\r\n  @mixin c($child) {\r\n    &-#{$child} {\r\n      @content;\r\n    }\r\n  }\r\n  \r\n  // Media Query Mixin\r\n  @mixin respond($respond) {\r\n    @media only screen and (max-width: #{$respond}) {\r\n      @content;\r\n    }\r\n  }\r\n  \r\n  // Position fixing (generally used for forms)\r\n  /*\r\n    E.g. \r\n    @include mix.position-fix(-15px, 0 0 -15px 0);\r\n    @include mix.respond(1280px) { @include mix.position-reset(); }\r\n  */\r\n  @mixin position-fix($top, $margin: 0 0 0 0) {\r\n    margin: $margin;\r\n    position: relative;\r\n    top: $top;\r\n  }\r\n  \r\n  @mixin position-reset() {\r\n    margin: 0;\r\n    position: static;\r\n    top: 0;\r\n  }","// Not seeing where /ascend is being used.\r\n@use \"./src/styles/abstracts/mixins\" as mix;\r\n\r\n.asterisk_input::after {\r\n  content: \" *\";\r\n  color: #ba5a73;\r\n}\r\n\r\n.mat-stepper-horizontal {\r\n  margin-top: 8px;\r\n}\r\n\r\n.uploaded-document {\r\n  align-items: center;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  padding: 0.85em 0;\r\n\r\n  &:first-of-type {\r\n    padding-top: 0;\r\n  }\r\n\r\n  &:last-of-type {\r\n    padding-bottom: 0;\r\n  }\r\n\r\n  &:not(:last-of-type) {\r\n    border-bottom: 1px solid rgba(0, 0, 0, 0.07);\r\n  }\r\n\r\n  p {\r\n    margin-bottom: 0;\r\n    margin-top: 0;\r\n  }\r\n\r\n  @include mix.e(item) {\r\n    display: flex;\r\n  }\r\n\r\n  @include mix.e(title) {\r\n    margin-right: 25px;\r\n  }\r\n\r\n  @include mix.e(name) {\r\n  }\r\n\r\n  @include mix.e(remove) {\r\n    font-size: 25px;\r\n  }\r\n}\r\n\r\n.mat-mdc-raised-button.mat-blue {\r\n  background-color: #5479b9;\r\n  color: white;\r\n}\r\n\r\n.mat-mdc-raised-button.mat-gray {\r\n  background-color: #c7c7c7;\r\n  color: white;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
